<template>
  <v-tabs
    v-model="active"
    centered
    slider-color="secondary"
    class="v-tabs-reports v-tabs-reports--drawer"
  >
    <v-tab
      v-for="item in ['information', 'rides']"
      :key="item"
      ripple
      class="pl-0"
      style="width: 50%"
    >
      {{ $t(`${namespace}.${item}`) }}
    </v-tab>

    <v-tab-item>
      <v-card class="pa-4 overflow--y" :style="`height: ${contentHeight}px`" flat>
        <TabInfo
          v-if="hasRole('employee', 'ROLE_GET_EMPLOYEE_ID')"
          :data="data"
          @change="change"
        />

        <EmptyState
          v-else
          image="employee"
          :imageSize="120"
          class="px-4"
        >
          <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
        </EmptyState>
      </v-card>
    </v-tab-item>

    <v-tab-item>
      <v-card flat>
        <RideList
          :data="data"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { hasRole, calcContentHeight } from 'utils/functions'
import TabInfo from './TabInfo'
import RideList from 'components/globalDrawer/rideList'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Tabs',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    TabInfo,
    RideList,
    EmptyState
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.employee.tabs',
      active: 0,
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight() - 65
    },

    change (val) {
      this.$emit('change', val)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss">
.v-tabs.v-tabs-reports--drawer {

  .v-tabs__container.v-tabs__container--centered {
    margin-left: 0;
  }
}

.name {
  display: block;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  line-height: 1.43;
}

.item__label,
.item__text {
  display: block;
}

.item__label {
  color: $gray-6;
  font-size: 12px;
}
</style>
